import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

// Polyfill for https://rxjs-dev.firebaseapp.com/api/index/function/firstValueFrom
export async function firstValueFrom<T>(source: Observable<T>): Promise<T> {
  return source.pipe(first()).toPromise();
}
